import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../common/services/common-data.service';
import { LoginService } from '../../common/services/Login.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import { SessionService } from '../../common/services/Session.service';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html'
})
export class HelpComponent implements OnInit, AfterViewChecked {

  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService, private session: SessionService,
    private graphQlService: GraphqlService, private router: Router, private sanitizer: DomSanitizer, private openlinkid: OpenLinkById) { }
  help_header;
  help_description;
  help_topicsHeader;
  help_topicsDescription;
  help_mainNavigationHeader;
  help_mainNavigationLinks;
  help_seeAlsoHeader;
  help_seeAlsoLinks;
  s3bucketbasepath;
  ngOnInit(): void {
    this.checkSession();
    this.graphQlService.getS3BucketImagePath().subscribe(data => {
      this.s3bucketbasepath = data;
    });
    
    this.commonDataService.showLoader.next(true);
    this.gethelpcomponentlabels();
  }

  userRole: string = "";
  checkSession() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.userRole = data.user.roles;
      })
    }
    else { this.userRole = this.session.userInfo.user.roles; }
  }

  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {
    if (this.firstTimeFlag) {
      this.anchorColorChange();
      this.firstTimeFlag = false;
    }
  }

  anchorColorChange() {
    let item1 = document.getElementById('mainNavigationLinks')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    
    let item2 = document.getElementById('help_otherFeaturesLinks')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    
    let item3 = document.getElementById('help_seeAlsoLinks')?.getElementsByTagName("a") as HTMLCollectionOf<HTMLElement>;
    let item4 = document.getElementById('help_seeAlsoLinks')?.getElementsByTagName("span") as HTMLCollectionOf<HTMLElement>;

    if (item1 != undefined) {
      for (let i = 0; i < item1.length; i++) {
        let element = item1[i];
        element.style.color = "#005CBF";
        element.setAttribute("tabIndex","0");
      }
    }
    if (item2 != undefined) {
      for (let j = 0; j < item2.length; j++) {
        let element = item2[j];
        element.style.color = "#005CBF";
        element.setAttribute("tabIndex", "0");

      }
    }
    if (item3 != undefined) {
      for (let k = 0; k < item3.length; k++) {
        let element = item3[k];
        element.style.color = "#005CBF";

      }
    }
    if (item4 != undefined) {
      for (let l = 0; l < item4.length; l++) {
        let element = item4[l];
        element.setAttribute("tabIndex", "0");
      }
    }
  }
  help_seeAlsoLinksPro;
  help_mainNavigationLinksPro;
  gethelpcomponentlabels() {
    this.graphQlService.getHelpComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.help_header = labels.filter(x => x.key == "help_header").map(y => y.value);
        this.help_description = labels.filter(x => x.key == "help_description").map(y => y.value);
        this.help_topicsHeader = labels.filter(x => x.key == "help_topicsHeader").map(y => y.value);
        this.help_topicsDescription = labels.filter(x => x.key == "help_topicsDescription").map(y => y.value);
        this.help_mainNavigationHeader = labels.filter(x => x.key == "help_mainNavigationHeader").map(y => y.value);
        this.help_mainNavigationLinks = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "help_mainNavigationLinks").map(y => y.value));
        this.help_mainNavigationLinksPro = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "help_mainNavigationLinksPro").map(y => y.value));
        this.help_seeAlsoHeader = labels.filter(x => x.key == "help_seeAlsoHeader").map(y => y.value);
        this.help_seeAlsoLinks = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "help_seeAlsoLinks").map(y => y.value));
        this.help_seeAlsoLinksPro = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "help_seeAlsoLinks_Pro").map(y => y.value));
        this.firstTimeFlag = true;
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  openlink(event) {
    event.preventDefault();
    let id = event.target.parentElement.id;
    let href = event.target.parentElement.href != undefined ? event.target.parentElement.href.split("/") : event.target.parentElement.href;
    if (href != undefined) {
      if (id != "" && (id.toLowerCase().replace("./", "") == href[href.length - 1])) {
        this.router.navigate([event.target.parentElement.id]);
      }
    }
  }
  onRightClick(event) {
    let id = event.target.id;
    if (id != "") {
      event.target.href = this.s3bucketbasepath +"/"+event.target.id;
    }
  }
  openLinkById(event) {
    event.preventDefault();
    this.openlinkid.openLinkById(event,true);
  }

}
